import { Button } from '@ch/common/components/button';
import { CustomFlowId, Question, questionFieldType } from '@ch/common/types/data';
import React, { FC } from 'react';
import QuizField from './quiz-field';
import QuizHeading from './quiz-heading';
import { useData } from '../use-data';
import { QuizQuestionWrapper, QuizSectionHidden } from './quiz.styled';

const QuizQuestion: FC<{ fullWidth: boolean; question: Question; list: Question[]; customLayout: boolean }> = ({
  fullWidth,
  question,
  list,
  customLayout,
}) => {
  const { identifier, question: title, field_type: type, value } = question;
  const {
    data: {
      theme: { btnDark },
    },
  } = useData();
  switch (identifier) {
    case CustomFlowId.SUBMIT:
      return (
        <Button type="submit" $fullWidth $defaultColor={{ ...btnDark }} $color="red">
          {value}
        </Button>
      );
  }
  if (type === questionFieldType.LABEL) {
    return (
      <QuizQuestionWrapper>
        <QuizHeading {...{ customLayout }}>{title}</QuizHeading>
        <QuizSectionHidden id={identifier} />
      </QuizQuestionWrapper>
    );
  }

  return <QuizField {...{ fullWidth, ...question, subQuestions: list }} />;
};

export default QuizQuestion;
